<template>
<div >
	<Navbar></Navbar>
	<div class="main-content">
		<Loader :show="loading"></Loader>
		<div class=" container" v-if="!loading">	
			
			<div class="row row-xs mt-2">
				<div class="col">
					<h4 class="mt-3 ml-2">Configuraciones</h4>
					<div class="card mt-3">
						<div class="card-body p-4">

							<div class="p-4">
								<b-form-checkbox
									class="mt-4 mb-3"
									id="checkbox-1"
									v-model="form.enableCounts"
									name="checkbox-1"
									>
									Habilitar conteo de vehículos en POS
								</b-form-checkbox>


								<b-form-group label="Precio por Litro de Nafta" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.fuelPriceGasoline" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>
								
								<b-form-group label="Precio por Litro de Gasoil" class="mb-3 mr-4">
									<div class="input-group" style="width:120px;">
										<div class="input-group-prepend">
											<span class="input-group-text">U$S</span>
										</div>
										<vue-numeric 
											separator="," 
											v-model="form.fuelPriceDiesel" 
											class="form-control text-right" 
											:precision="2" ></vue-numeric>
									</div>
									<b-form-invalid-feedback>Ingrese un precio válido</b-form-invalid-feedback>
								</b-form-group>

								<hr>				

								<div class="overflow-hidden mt-4">
									<b-button type="button" @click="update()" class="pull-right" size="sm" variant="primary">Guardar cambios</b-button>
								</div>
							</div>
						</div>
					

					</div>
					
					<h4 class="mt-4 ml-2">Reportes</h4>
					<div class="card mt-3">
						<div class="card-body p-4">

							<div class="p-4">
								
								<div class="d-flex justify-content-between">
									<label>Exportar vehículos contabilizados</label>
									<select class="form-control" 
										style="max-width:230px"
										v-model="exportables.registeredCars.deposit" 
									>
										<option v-for="deposit in deposits" :key="deposit.id" :value="deposit.id">{{deposit.title}}</option>
									</select> 
									<date-picker
										style="max-width:230px"
										v-model="exportables.registeredCars.dateRange" 
										type="date" 
										range 
										placeholder="Filtrar por rango de fechas"
										value-type="YYYY-MM-DD" 
										format="DD-MM-YYYY"
									></date-picker>
									<b-button type="button" @click="exportRegisteredCars()" class="pull-right" size="sm" variant="primary">Exportar</b-button>
								</div>
								
								<hr>
								
								<div class="d-flex justify-content-between">
									<label>Exportar balance de vehículos por cliente</label>
									<select class="form-control" 
										style="max-width:230px"
										v-model="exportables.carsByClient.clientId" 
									>
										<option v-for="client in clients" :key="client.id" :value="client.id">{{client.name}}</option>
									</select>
									<date-picker
										style="max-width:230px"
										v-model="exportables.carsByClient.dateRange" 
										type="date" 
										range 
										placeholder="Filtrar por rango de fechas"
										value-type="YYYY-MM-DD" 
										format="DD-MM-YYYY"
									></date-picker>
									<b-button type="button" @click="exportCarsByClient()" class="pull-right" size="sm" variant="primary">Exportar</b-button>
								</div>

								<hr>

							</div>
						</div>
					

					</div>
					
				</div>
			</div>

		</div>
	</div>

</div>
</template>


<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import Navbar from '@/components/Navbar'
import Loader from '@/components/Loader'
import { buildExportUrl } from '@/lib/exportsUrl'


export default {
	name: 'settings',
	mixins:[mixins],
	components:{
		Navbar,
		Loader
	},
	data () {
		return {
			API_URL: process.env.VUE_APP_API_URL,
			loading: true,
			clients:[],
			deposits:[],
			form:{
				enableCounts: false,
				fuelPriceGasoline:0,
				fuelPriceDiesel:0,
			},
			exportables:{
				registeredCars: {
					dateRange: null
				},
				carsByClient:{
					clientId: null
				}
			}
		}
	},
	beforeMount(){
		this.load();
	},
	methods:{
		load(){
			this.$apollo.query({
				query: gql`query  {
					settings {
						enableCounts
						fuelPriceGasoline
						fuelPriceDiesel
					}
					clientsAll{
						id
						name
					},
					deposits{
						id
						title
					}
				}`,
			})
			.then((data) => {
				this.form = data.data.settings
				this.deposits = data.data.deposits
				this.clients = data.data.clientsAll
				this.loading = false
			})
		},
		update () {
			var dataInput = {
				enableCounts:		 this.form.enableCounts,
				fuelPriceGasoline:	 this.form.fuelPriceGasoline,
				fuelPriceDiesel:	 this.form.fuelPriceDiesel,
			}
			this.$apollo.mutate({
				mutation: gql`mutation ( $data:SettingInput! ){
					settingsUpdate( data: $data) {
						enableCounts
					}
				}`,
				variables: {
					data: dataInput,
				}
			})
			.then(() => {
				this.$toast.success('Cambios guardados')
				this.saving = false
			})
			.catch( (error) => {
				this.errors = this.parseGQLErrors(error)
				this.$toast.error('Error!')
				this.saving = false
			})
		},
		exportRegisteredCars(){
			const deposit = this.exportables.registeredCars.deposit
			const from = this.exportables.registeredCars.dateRange[0]
			const to = this.exportables.registeredCars.dateRange[1]
			if(from && to){
				window.open(buildExportUrl('export-cars-registered', { from, to, deposit }), '_blank');
			}
		},
		exportCarsByClient(){
			const from = this.exportables.carsByClient.dateRange[0]
			const to = this.exportables.carsByClient.dateRange[1]
			const clientId = this.exportables.carsByClient.clientId
			if(clientId && from && to){
				window.open(buildExportUrl('export-cars-by-client', { clientId, from, to }), '_blank');
			}
		}
	}
}


</script>

<style scoped>

</style>
